module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Reports px-4"
  }, [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "top": "",
      "color": _vm.snackbar.color,
      "rounded": "",
      "centered": ""
    },
    model: {
      value: (_vm.snackbar.show),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "show", $$v)
      },
      expression: "snackbar.show"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar.text) + "\n  ")]), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 2000,
      "top": "",
      "color": "green",
      "rounded": "",
      "centered": ""
    },
    model: {
      value: (_vm.showSurveySnackbar),
      callback: function($$v) {
        _vm.showSurveySnackbar = $$v
      },
      expression: "showSurveySnackbar"
    }
  }, [_c('p', {
    staticClass: "mb-0 text-center"
  }, [_vm._v(_vm._s(_vm.$t('SatisfactionSurveyModal.thankYou')))])]), _vm._v(" "), (_vm.satisfactionSurveyModal) ? _c('SatisfactionSurveyModal', {
    attrs: {
      "dialog": _vm.satisfactionSurveyModal,
      "questions": _vm.SATISFACTION_SURVEY_QUESTIONS,
      "declineBtnCallback": _vm.declineSatisfactionSurvey,
      "confirmBtnCallback": _vm.saveSatisfactionSurveyResponse,
      "functionality": _vm.FUNCTIONALITY
    },
    on: {
      "update:dialog": function($event) {
        _vm.satisfactionSurveyModal = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-container', [_c('Header', {
    attrs: {
      "reportDates": _vm.organizationData.reportDates,
      "orgInfo": _vm.organizationData.orgInfo,
      "cardsData": _vm.headerCardsData,
      "loadingQuery": _vm.$apollo.queries.organizationData.loading,
      "date": _vm.date
    },
    on: {
      "changeReport": _vm.changeReportHandler
    }
  }), _vm._v(" "), _c('v-container', {
    staticClass: "CardsHeader d-flex pa-0 mt-5 mb-3",
    attrs: {
      "fluid": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("Reports.equipmentPerformance")))]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), (_vm.$apollo.queries.equipmentsData.loading) ? _c('v-container', {
    staticClass: "display-1 text-center mt-5",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "#0098E1"
    }
  })], 1) : (_vm.validEquipments.length === 0) ? _c('v-container', {
    staticClass: "display-1 text-center grey--text",
    attrs: {
      "fluid": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("Reports.noReports")) + "\n      ")]) : _vm._l((_vm.validEquipments), function(equip) {
    return _c('MainCard', {
      key: equip.id,
      attrs: {
        "id": ((equip.id) + "-main-card"),
        "equipData": equip.equipData,
        "locations": equip.locations,
        "badgesInfo": equip.badges,
        "lot": _vm.lot,
        "deviceId": _vm.deviceId,
        "firstLoad": _vm.firstScroll,
        "faultsEvery100hsAverage": _vm.faultsEvery100hsAverage
      }
    })
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-335f58de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/Reports.vue
// module id = 1699
// module chunks = 0